import { useContext } from "react";
import { BtcPriceContext } from "../contexts/BtcPriceContext";

const useBtcPrice = () => useContext(BtcPriceContext);

export default useBtcPrice;
